import { render, staticRenderFns } from "./record-dialog.vue?vue&type=template&id=2229dd17&scoped=true&"
import script from "./record-dialog.vue?vue&type=script&lang=js&"
export * from "./record-dialog.vue?vue&type=script&lang=js&"
import style0 from "./record-dialog.vue?vue&type=style&index=0&id=2229dd17&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2229dd17",
  null
  
)

export default component.exports